import { render } from "./ConfigureAPI.vue?vue&type=template&id=664c56ac"
import script from "./ConfigureAPI.vue?vue&type=script&lang=js"
export * from "./ConfigureAPI.vue?vue&type=script&lang=js"

import "./ConfigureAPI.vue?vue&type=style&index=0&id=664c56ac&lang=scss"
script.render = render

export default script